// Shared video styles data for AI animation showcase
// Supabase public bucket: style-videos
// Project ID: cejhviamcxoicnnjwvdh

const SUPABASE_BASE_URL = 'https://cejhviamcxoicnnjwvdh.supabase.co/storage/v1/object/public/style-videos/';

interface Style {
  name: string;
  src: string;
}

// Generate style data from filenames
const filenames = [
  'Acid.mp4',
  'Akrill.mp4',
  'Broken Mirror.mp4',
  'Bubbles.mp4',
  'Cannabis.mp4',
  'Canvas.mp4',
  'Cold Vision.mp4',
  'Comic.mp4',
  'Flash Comic.mp4',
  'Fragments.mp4',
  'Hand Paint.mp4',
  'Lava.mp4',
  'Layer Mixed Media.mp4',
  'LSD.mp4',
  'Magazine.mp4',
  'Marble.mp4',
  'Modern.mp4',
  'Multiverse.mp4',
  'Noir.mp4',
  'Ocean.mp4',
  'Origami.mp4',
  'Overexposed.mp4',
  'Palette.mp4',
  'Paper.mp4',
  'Particles.mp4',
  'Random Glow.mp4',
  'Sketch.mp4',
  'Toxic.mp4',
  'Tracking.mp4',
  'Two Color.mp4',
  'Ultra Violet.mp4',
  'Vintage.mp4',
  'Windows.mp4',
];

export const styles: Style[] = filenames.map((filename) => ({
  name: filename.replace('.mp4', ''),
  src: SUPABASE_BASE_URL + encodeURIComponent(filename),
}));
